import React, { Fragment, useState, useEffect } from 'react';
import { Card, Col, Row, Breadcrumb, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import './resumen.scss';
import { estadisticasResumenService } from '../../services/estadisticasResumenService';
import { useAuth } from '../../hooks/useAuth';

import ReactApexChart from 'react-apexcharts';

const Resumen = () => {
    // Hook de autenticación
    const { user, asesorId, isAuthenticated } = useAuth();

    const [showFilters, setShowFilters] = useState(false);

    // Estados para el filtro de fechas
    const [fechaDesde, setFechaDesde] = useState('');
    const [fechaHasta, setFechaHasta] = useState('');

    // Estados para el filtro de proyectos
    const [proyectos, setProyectos] = useState([]);
    const [proyectoSeleccionado, setProyectoSeleccionado] = useState('');

    // Estado para las estadísticas de resumen
    const [estadisticasResumen, setEstadisticasResumen] = useState({
        embudoDeConversion: {
            prospectos: { total: 0, porcentajeTotal: 0 },
            contactados: { total: 0, porcentajeTotal: 0 },
            derivados: { total: 0, porcentajeTotal: 0 },
            citados: { total: 0, porcentajeTotal: 0 }
        },
        estadisticasLeadClasificacion: {
            pendiente: { total: 0, porcentajeTotal: 0 },
            bajo: { total: 0, porcentajeTotal: 0 },
            medio: { total: 0, porcentajeTotal: 0 },
            alto: { total: 0, porcentajeTotal: 0 },
            descartado: { total: 0, porcentajeTotal: 0 }
        },
        conversacionesAbandonadas: {
            contactados: 0,
            abandonados: 0,
            recuperados: 0
        },
        asistenciaHumana: {
            total: 0,
            porcentajeTotal: 0
        },
        heatmapVolumenMensajes: {
            heatmap: {
                domingo: {
                    "00:00": 0, "01:00": 0, "02:00": 0, "03:00": 0, "04:00": 0, "05:00": 0,
                    "06:00": 0, "07:00": 0, "08:00": 0, "09:00": 0, "10:00": 0, "11:00": 0,
                    "12:00": 0, "13:00": 0, "14:00": 0, "15:00": 0, "16:00": 0, "17:00": 0,
                    "18:00": 0, "19:00": 0, "20:00": 0, "21:00": 0, "22:00": 0, "23:00": 0
                },
                lunes: {
                    "00:00": 0, "01:00": 0, "02:00": 0, "03:00": 0, "04:00": 0, "05:00": 0,
                    "06:00": 0, "07:00": 0, "08:00": 0, "09:00": 0, "10:00": 0, "11:00": 0,
                    "12:00": 0, "13:00": 0, "14:00": 0, "15:00": 0, "16:00": 0, "17:00": 0,
                    "18:00": 0, "19:00": 0, "20:00": 0, "21:00": 0, "22:00": 0, "23:00": 0
                },
                martes: {
                    "00:00": 0, "01:00": 0, "02:00": 0, "03:00": 0, "04:00": 0, "05:00": 0,
                    "06:00": 0, "07:00": 0, "08:00": 0, "09:00": 0, "10:00": 0, "11:00": 0,
                    "12:00": 0, "13:00": 0, "14:00": 0, "15:00": 0, "16:00": 0, "17:00": 0,
                    "18:00": 0, "19:00": 0, "20:00": 0, "21:00": 0, "22:00": 0, "23:00": 0
                },
                miercoles: {
                    "00:00": 0, "01:00": 0, "02:00": 0, "03:00": 0, "04:00": 0, "05:00": 0,
                    "06:00": 0, "07:00": 0, "08:00": 0, "09:00": 0, "10:00": 0, "11:00": 0,
                    "12:00": 0, "13:00": 0, "14:00": 0, "15:00": 0, "16:00": 0, "17:00": 0,
                    "18:00": 0, "19:00": 0, "20:00": 0, "21:00": 0, "22:00": 0, "23:00": 0
                },
                jueves: {
                    "00:00": 0, "01:00": 0, "02:00": 0, "03:00": 0, "04:00": 0, "05:00": 0,
                    "06:00": 0, "07:00": 0, "08:00": 0, "09:00": 0, "10:00": 0, "11:00": 0,
                    "12:00": 0, "13:00": 0, "14:00": 0, "15:00": 0, "16:00": 0, "17:00": 0,
                    "18:00": 0, "19:00": 0, "20:00": 0, "21:00": 0, "22:00": 0, "23:00": 0
                },
                viernes: {
                    "00:00": 0, "01:00": 0, "02:00": 0, "03:00": 0, "04:00": 0, "05:00": 0,
                    "06:00": 0, "07:00": 0, "08:00": 0, "09:00": 0, "10:00": 0, "11:00": 0,
                    "12:00": 0, "13:00": 0, "14:00": 0, "15:00": 0, "16:00": 0, "17:00": 0,
                    "18:00": 0, "19:00": 0, "20:00": 0, "21:00": 0, "22:00": 0, "23:00": 0
                },
                sabado: {
                    "00:00": 0, "01:00": 0, "02:00": 0, "03:00": 0, "04:00": 0, "05:00": 0,
                    "06:00": 0, "07:00": 0, "08:00": 0, "09:00": 0, "10:00": 0, "11:00": 0,
                    "12:00": 0, "13:00": 0, "14:00": 0, "15:00": 0, "16:00": 0, "17:00": 0,
                    "18:00": 0, "19:00": 0, "20:00": 0, "21:00": 0, "22:00": 0, "23:00": 0
                }
            },
            estadisticas: {
                horaPicoMatutina: { hora: 'N/A', totalMensajes: 0 },
                horaPicoVespertina: { hora: 'N/A', totalMensajes: 0 },
                horaMenorActividad: { hora: 'N/A', totalMensajes: 0 },
                diaPicoSemana: { dia: 'N/A', totalMensajes: 0 },
                mesPico: { mes: 'N/A', totalMensajes: 0 }
            }
        }
    });

    const [loadingEstadisticas, setLoadingEstadisticas] = useState(false);

    // Función para obtener el primer y último día del mes actual
    const obtenerRangoMesActual = () => {
        const fechaActual = new Date();
        const primerDiaMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
        const ultimoDiaMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0);

        // Formatear fechas para input type="date" (YYYY-MM-DD)
        const formatearFecha = (fecha) => {
            const año = fecha.getFullYear();
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const dia = String(fecha.getDate()).padStart(2, '0');
            return `${año}-${mes}-${dia}`;
        };

        return {
            desde: formatearFecha(primerDiaMes),
            hasta: formatearFecha(ultimoDiaMes)
        };
    };

    // Establecer fechas por defecto al montar el componente
    useEffect(() => {
        const rangoMes = obtenerRangoMesActual();
        setFechaDesde(rangoMes.desde);
        setFechaHasta(rangoMes.hasta);
    }, []);

    // Cargar lista de proyectos según el rol del usuario
    useEffect(() => {
        const cargarProyectos = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) return;

                const esAdmin = user?.rol === 'admin' || user?.rol === 'super_admin';
                const url = esAdmin
                    ? '/api/proyecto/empresa'
                    : `/api/proyecto/vendedor/${asesorId}/proyectos`;

                const res = await fetch(url, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                const data = await res.json();
                // La respuesta puede ser un array directo o un objeto con data
                const lista = Array.isArray(data) ? data : (data.data || []);
                setProyectos(lista);
            } catch (err) {
                console.error('Error cargando proyectos:', err);
            }
        };

        if (isAuthenticated && user) {
            cargarProyectos();
        }
    }, [isAuthenticated, user, asesorId]);

    // Función para cargar estadísticas
    const cargarEstadisticas = async (fechaDesdeParam = null, fechaHastaParam = null, proyectoIdParam = null) => {
        try {
            setLoadingEstadisticas(true);

            const token = localStorage.getItem('token');
            if (!token) {
                console.error('No hay token de autenticación');
                return;
            }

            const fechaDesdeFinal = fechaDesdeParam || fechaDesde;
            const fechaHastaFinal = fechaHastaParam || fechaHasta;
            const proyectoIdFinal = proyectoIdParam !== null ? proyectoIdParam : proyectoSeleccionado;

            const data = await estadisticasResumenService.getEstadisticasResumen(token, fechaDesdeFinal, fechaHastaFinal, proyectoIdFinal || null);
            console.log('🎯 [Resumen] Estadísticas cargadas:', data);
            setEstadisticasResumen(data);
        } catch (error) {
            console.error('Error al cargar estadísticas de resumen:', error);
        } finally {
            setLoadingEstadisticas(false);
        }
    };

    // Cargar datos al montar el componente
    useEffect(() => {
        if (isAuthenticated) {
            cargarEstadisticas();
        }
    }, [isAuthenticated]);

    return (
        <div className="resumen-container">
            <div className="breadcrumb-header">
                <Breadcrumb>
                    <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
                    <Breadcrumb.Item active>Resumen</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <div className="resumen-main-container">
                <div className="page-header">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h3 className="page-title">Resumen</h3>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <label style={{ fontSize: 14, fontWeight: 500, color: '#666' }}>Proyecto:</label>
                                <select
                                    value={proyectoSeleccionado}
                                    onChange={(e) => {
                                        const nuevoProyecto = e.target.value;
                                        setProyectoSeleccionado(nuevoProyecto);
                                        cargarEstadisticas(fechaDesde, fechaHasta, nuevoProyecto);
                                    }}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        minWidth: 180,
                                        backgroundColor: '#fff'
                                    }}
                                >
                                    <option value="">Todos los proyectos</option>
                                    {proyectos.map((p) => (
                                        <option key={p.codigoProyecto} value={p.codigoProyecto}>{p.nombreProyecto}</option>
                                    ))}
                                </select>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <label style={{ fontSize: 14, fontWeight: 500, color: '#666' }}>Desde:</label>
                                <input
                                    type="date"
                                    value={fechaDesde}
                                    onChange={(e) => {
                                        const nuevaFecha = e.target.value;
                                        setFechaDesde(nuevaFecha);
                                        cargarEstadisticas(nuevaFecha, fechaHasta, proyectoSeleccionado);
                                    }}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        fontSize: '14px'
                                    }}
                                />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <label style={{ fontSize: 14, fontWeight: 500, color: '#666' }}>Hasta:</label>
                                <input
                                    type="date"
                                    value={fechaHasta}
                                    onChange={(e) => {
                                        const nuevaFecha = e.target.value;
                                        setFechaHasta(nuevaFecha);
                                        cargarEstadisticas(fechaDesde, nuevaFecha, proyectoSeleccionado);
                                    }}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        fontSize: '14px'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="resumen-separador"></div>
                </div>
                <Row className="row-sm g-3">
                    {/* Embudo de conversión y Lead scoring */}
                    <Col xl={6}>
                        <Card className="custom-card">
                            <Card.Header>
                                <Card.Title>Embudo de conversión</Card.Title>
                            </Card.Header>
                            <Card.Body
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    minHeight: 380,
                                }}
                            >
                                {loadingEstadisticas ? (
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexDirection: 'column',
                                        gap: 16
                                    }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Cargando...</span>
                                        </div>
                                        <span>Cargando estadísticas...</span>
                                    </div>
                                ) : (
                                    <div style={{ width: 420, maxWidth: "100%", height: 260, display: 'flex', alignItems: 'center' }}>
                                        <EmbudoConversionVisual estadisticas={estadisticasResumen} />
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xl={6}>
                        <Card className="custom-card">
                            <Card.Header>
                                <Card.Title>Lead scoring</Card.Title>
                            </Card.Header>
                            <Card.Body
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    minHeight: 380,
                                }}
                            >
                                {loadingEstadisticas ? (
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexDirection: 'column',
                                        gap: 16
                                    }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Cargando...</span>
                                        </div>
                                        <span>Cargando estadísticas...</span>
                                    </div>
                                ) : (
                                    <div style={{ width: 420, maxWidth: "100%" }}>
                                        <LeadScoringBar height={260} estadisticas={estadisticasResumen} />
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="row-sm g-3 mt-2">
                    {/* Conversaciones abandonadas y Asistencia humana */}
                    <Col xl={6}>
                        <Card className="custom-card">
                            <Card.Header>
                                <Card.Title>Conversaciones abandonadas</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                {loadingEstadisticas ? (
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexDirection: 'column',
                                        gap: 16,
                                        minHeight: 320
                                    }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Cargando...</span>
                                        </div>
                                        <span>Cargando estadísticas...</span>
                                    </div>
                                ) : (
                                    <div style={{ height: 260, display: 'flex', alignItems: 'center' }}>
                                        <ConversacionesAbandonadasArea estadisticas={estadisticasResumen} />
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xl={6}>
                        <Card className="custom-card">
                            <Card.Header>
                                <Card.Title>Asistencia humana</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                {loadingEstadisticas ? (
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexDirection: 'column',
                                        gap: 16,
                                        minHeight: 320
                                    }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Cargando...</span>
                                        </div>
                                        <span>Cargando estadísticas...</span>
                                    </div>
                                ) : (
                                    <div style={{ maxWidth: 420, margin: "0 auto", height: 260, display: 'flex', alignItems: 'center' }}>
                                        <AsistenciaHumanaDonut estadisticas={estadisticasResumen} />
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Gráfico de volumen de mensajes por hora y día - Ocupa todo el ancho */}
                <Row className="row-sm g-3 mt-2">
                    <Col xl={12}>
                        <Card className="custom-card">
                            <Card.Header>
                                <Card.Title>Resumen de Mensajes por Periodo</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                {loadingEstadisticas ? (
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexDirection: 'column',
                                        gap: 16,
                                        minHeight: 320
                                    }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Cargando...</span>
                                        </div>
                                        <span>Cargando estadísticas...</span>
                                    </div>
                                ) : (
                                    <div style={{ height: 400, display: 'flex', alignItems: 'center' }}>
                                        <VolumenMensajesHeatmap estadisticas={estadisticasResumen} />
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

const AsistenciaHumanaDonut = ({ estadisticas }) => {
    // Usar datos reales de la nueva métrica 'asistenciaHumana'
    // Si la API antigua no lo envía, usar 0 por defecto.
    const asistenciaData = estadisticas.asistenciaHumana || { porcentajeTotal: 0, total: 0 };

    const porcentajeSi = asistenciaData.porcentajeTotal;
    // Aseguramos que no salga negativo por redondeo
    const porcentajeNo = Math.max(0, 100 - porcentajeSi);

    const series = [porcentajeSi, porcentajeNo];
    const options = {
        chart: {
            type: 'donut',
            height: 260,
        },
        labels: ['Si', 'No'],
        colors: ['#6A8BFF', '#B6C5FF'],
        dataLabels: {
            enabled: false
        },
        legend: {
            show: false
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '75%',
                    labels: {
                        show: true,
                        name: { show: false },
                        value: { show: false },
                        total: {
                            show: true,
                            showAlways: true,
                            label: '',
                            fontSize: '48px',
                            fontWeight: 700,
                            color: '#000',
                            formatter: function (w) {
                                return porcentajeSi + "%"
                            }
                        }
                    }
                }
            }
        },
        stroke: {
            width: 0
        }
    };
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ width: 220, height: 220, position: 'relative' }}>
                <ReactApexChart options={options} series={series} type="donut" height={220} />
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'none',
                }}>
                    <span style={{ fontSize: 48, fontWeight: 700, color: '#000', lineHeight: 1 }}>{porcentajeSi.toFixed(1)}%</span>
                </div>
            </div>
            <div style={{ marginLeft: 32 }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                    <span style={{ width: 14, height: 14, borderRadius: '50%', background: '#6A8BFF', display: 'inline-block', marginRight: 8 }}></span>
                    <span style={{ color: '#222', fontWeight: 500, marginRight: 8 }}>Sí</span>
                    <span style={{ color: '#222', fontWeight: 700, minWidth: 40, textAlign: 'right', display: 'inline-block' }}>{porcentajeSi.toFixed(1)}%</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ width: 14, height: 14, borderRadius: '50%', background: '#B6C5FF', display: 'inline-block', marginRight: 8 }}></span>
                    <span style={{ color: '#222', fontWeight: 500, marginRight: 8 }}>No</span>
                    <span style={{ color: '#222', fontWeight: 700, minWidth: 40, textAlign: 'right', display: 'inline-block' }}>{porcentajeNo.toFixed(1)}%</span>
                </div>
            </div>
        </div>
    );
};

// COMENTADO: UtilidadInformacionDonut - Componente comentado pero mantenido para futuras referencias
/* const UtilidadInformacionDonut = ({ height = 220 }) => {
    const series = [20, 10, 70];
    const labels = ['Sí', 'No', 'No responde'];
    const colors = ['#6A8BFF', '#B6C5FF', '#E8EAF6'];
    const centerValue = 70;
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height }}>
            <div style={{ width: height, height: height, position: 'relative' }}>
                <ReactApexChart
                    options={{
                        chart: { type: 'donut', height: height },
                        labels,
                        colors,
                        dataLabels: { enabled: false },
                        legend: { show: false },
                        plotOptions: { pie: { donut: { size: '75%' } } },
                        stroke: { width: 0 }
                    }}
                    series={series}
                    type="donut"
                    height={height}
                />
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'none',
                }}>
                    <span style={{ fontSize: 48, fontWeight: 700, color: '#222', lineHeight: 1 }}>{centerValue}%</span>
                </div>
            </div>
            <div style={{ marginLeft: 32 }}>
                {labels.map((label, i) => (
                    <div key={label} style={{ display: 'flex', alignItems: 'center', marginBottom: i < labels.length - 1 ? 12 : 0 }}>
                        <span style={{ width: 14, height: 14, borderRadius: '50%', background: colors[i], display: 'inline-block', marginRight: 8 }}></span>
                        <span style={{ color: '#222', fontWeight: 500, marginRight: 8 }}>{label}</span>
                        <span style={{ color: '#222', fontWeight: 700, minWidth: 40, textAlign: 'right', display: 'inline-block' }}>{series[i]}%</span>
                    </div>
                ))}
            </div>
        </div>
    );
}; */

// COMENTADO: TipoConversacionPie - Componente comentado pero mantenido para futuras referencias
/* const TipoConversacionPie = () => {
    const series = [25, 25, 25, 25];
    const labels = ['Otros', 'Venta', 'Reclama', 'Postventa'];
    const colors = ['#6A8BFF', '#8095E4', '#B6C5FF', '#E8EAF6'];
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ width: 220, height: 220, position: 'relative' }}>
                <ReactApexChart
                    options={{
                        chart: { type: 'pie', height: 260 },
                        labels,
                        colors,
                        dataLabels: { enabled: false },
                        legend: { show: false },
                        stroke: { width: 0 }
                    }}
                    series={series}
                    type="pie"
                    height={220}
                />
            </div>
            <div style={{ marginLeft: 32 }}>
                {labels.map((label, i) => (
                    <div key={label} style={{ display: 'flex', alignItems: 'center', marginBottom: i < labels.length - 1 ? 12 : 0 }}>
                        <span style={{ width: 14, height: 14, borderRadius: '50%', background: colors[i], display: 'inline-block', marginRight: 8 }}></span>
                        <span style={{ color: '#222', fontWeight: 500, marginRight: 8 }}>{label}</span>
                        <span style={{ color: '#222', fontWeight: 700, minWidth: 40, textAlign: 'right', display: 'inline-block' }}>25%</span>
                    </div>
                ))}
            </div>
        </div>
    );
}; */

const LeadScoringBar = ({ height = 320, estadisticas }) => {
    // Usar datos reales del estado global
    const leadData = estadisticas.estadisticasLeadClasificacion;
    console.log('📊 [FRONTEND DEBUG] LeadScoringData:', leadData);

    // Asegurar compatibilidad si no vienen los datos (legacy)
    const pendiente = leadData.pendiente || { porcentajeTotal: 0 };
    const bajo = leadData.bajo || { porcentajeTotal: 0 };
    const medio = leadData.medio || { porcentajeTotal: 0 };
    const alto = leadData.alto || { porcentajeTotal: 0 };
    const descartado = leadData.descartado || { porcentajeTotal: 0 };

    const series = [{
        name: 'Lead scoring',
        data: [
            pendiente.porcentajeTotal,
            bajo.porcentajeTotal,
            medio.porcentajeTotal,
            alto.porcentajeTotal,
            descartado.porcentajeTotal
        ]
    }];
    const categories = ['Pendiente', 'Bajo', 'Medio', 'Alto', 'Descartado'];
    const colors = ['#FFA726', '#6A8BFF', '#8095E4', '#B6C5FF', '#A9A9A9'];
    return (
        <div style={{ width: '100%', maxWidth: 600, margin: '0 auto', padding: '0' }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
                {categories.map((cat, i) => (
                    <div key={cat} style={{ display: 'flex', alignItems: 'center', marginRight: i < categories.length - 1 ? 24 : 0 }}>
                        <span style={{ width: 14, height: 14, borderRadius: '50%', background: colors[i], display: 'inline-block', marginRight: 8 }}></span>
                        <span style={{ color: '#8c9097', fontWeight: 500, fontSize: 16 }}>{cat}</span>
                    </div>
                ))}
            </div>
            <ReactApexChart
                options={{
                    chart: {
                        type: 'bar',
                        stacked: false,
                        toolbar: { show: false },
                        height: height,
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '100%',
                            barHeight: '100%',
                            distributed: true,
                            dataLabels: {
                                position: 'center',
                            },
                            borderRadius: 0,
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: (val, opts) => `${val}%`,
                        style: {
                            fontSize: '16px',
                            fontWeight: 700,
                            colors: ['#fff']
                        },
                    },
                    xaxis: {
                        categories: categories,
                        labels: { show: false },
                        axisBorder: { show: false },
                        axisTicks: { show: false },
                    },
                    yaxis: {
                        min: 0,
                        max: 100,
                        labels: {
                            show: true,
                            formatter: (val) => val === 0 || val === 100 ? val : '',
                            style: {
                                colors: '#8c9097',
                                fontSize: '14px',
                                fontWeight: 500,
                            },
                        },
                    },
                    grid: {
                        show: false,
                        padding: { left: 20, right: 20 },
                    },
                    legend: { show: false },
                    colors,
                    tooltip: {
                        enabled: true,
                        y: {
                            formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                                const totales = [
                                    pendiente.total || 0,
                                    bajo.total || 0,
                                    medio.total || 0,
                                    alto.total || 0,
                                    descartado.total || 0
                                ];
                                return `${totales[dataPointIndex]} leads (${value}%)`;
                            }
                        },
                        style: {
                            fontSize: '14px',
                            fontFamily: 'inherit'
                        }
                    },
                    fill: { opacity: 1 },
                    states: { hover: { filter: { type: 'none' } } },
                    bar: { borderRadius: 0 },
                }}
                series={series}
                type="bar"
                height={height}
            />
        </div>
    );
};

const EmbudoConversionVisual = ({ estadisticas }) => {
    // Usar datos reales del estado global
    const embudoData = estadisticas.embudoDeConversion;

    const steps = [
        {
            porcentaje: `${embudoData.prospectos.porcentajeTotal}%`,
            label: 'Prospectos',
            value: embudoData.prospectos.total.toLocaleString(),
            color: '#E8EAF6',
            width: '100%'
        },
        {
            porcentaje: `${embudoData.contactados.porcentajeTotal}%`,
            label: 'Contactados',
            value: embudoData.contactados.total.toLocaleString(),
            color: '#C5CAE9',
            width: '90%'
        },
        {
            porcentaje: `${embudoData.derivados.porcentajeTotal}%`,
            label: 'Derivados',
            value: embudoData.derivados.total.toLocaleString(),
            color: '#9FA8DA',
            width: '75%'
        },
        {
            porcentaje: `${embudoData.citados.porcentajeTotal}%`,
            label: 'Citados',
            value: embudoData.citados.total.toLocaleString(),
            color: '#6A8BFF',
            width: '60%'
        },
    ];
    return (
        <div style={{ width: '100%', padding: '8px 0' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {steps.map((step, i) => (
                    <div key={i} style={{
                        background: step.color,
                        borderRadius: 12,
                        padding: '18px 32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        fontWeight: 500,
                        fontSize: 18,
                        color: '#222',
                        minWidth: 220,
                        width: step.width,
                        margin: '0 auto',
                        boxShadow: '0 1px 4px 0 rgba(80,80,120,0.03)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        <span style={{ fontWeight: 700, fontSize: 22, color: (step.color === '#6A8BFF' || step.color === '#8095E4') ? '#fff' : '#6A8BFF', minWidth: 60, flexShrink: 0 }}>{step.porcentaje}</span>
                        <span style={{ opacity: 0.9, marginLeft: 16, flex: 1, textAlign: 'center', flexShrink: 0 }}>{step.label}</span>
                        <span style={{ fontWeight: 700, fontSize: 18, marginLeft: 16, minWidth: 50, textAlign: 'right', flexShrink: 0 }}>{step.value}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

const ConversacionesAbandonadasArea = ({ estadisticas }) => {
    // Usar datos reales del estado global
    const abandonosData = estadisticas.conversacionesAbandonadas;

    const series = [
        {
            name: 'Contactados',
            data: [abandonosData.contactados, abandonosData.contactados, abandonosData.contactados, abandonosData.contactados]
        },
        {
            name: 'Abandonos',
            data: [null, abandonosData.abandonados, abandonosData.abandonados, abandonosData.abandonados]
        },
        {
            name: 'Recuperados',
            data: [null, null, abandonosData.recuperados, abandonosData.recuperados]
        }
    ];
    const categories = ['Inicio', 'Abandonos', 'Recuperados', 'Fin'];
    const colors = ['#6A8BFF', '#8095E4', '#B6C5FF'];
    return (
        <div style={{ maxWidth: 420, margin: '0 auto' }}>
            <ReactApexChart
                options={{
                    chart: {
                        type: 'area',
                        height: 260,
                        toolbar: { show: false },
                    },
                    colors,
                    dataLabels: { enabled: false },
                    stroke: { curve: 'smooth', width: 3 },
                    xaxis: {
                        categories,
                        labels: { style: { colors: '#8c9097', fontWeight: 600 } },
                        axisBorder: { show: false },
                        axisTicks: { show: false },
                    },
                    yaxis: {
                        min: 0,
                        max: Math.max(abandonosData.contactados, abandonosData.abandonados, abandonosData.recuperados) + 20,
                        labels: { style: { colors: '#8c9097', fontWeight: 600 } },
                    },
                    legend: {
                        show: true,
                        position: 'top',
                        horizontalAlign: 'center',
                        labels: { colors: '#8c9097' },
                        fontWeight: 600,
                    },
                    fill: {
                        type: 'solid',
                        opacity: 0.25
                    },
                    grid: { show: false },
                    tooltip: { enabled: true },
                }}
                series={series}
                type="area"
                height={260}
            />
        </div>
    );
};

const VolumenMensajesHeatmap = ({ estadisticas }) => {
    // Usar datos reales de la API
    const datosHeatmap = estadisticas.heatmapVolumenMensajes?.heatmap || {};

    // Generar arrays dinámicamente desde los datos de la API
    const dias = Object.keys(datosHeatmap).map(dia => {
        const nombresDias = {
            lunes: 'Lunes',
            martes: 'Martes',
            miercoles: 'Miércoles',
            jueves: 'Jueves',
            viernes: 'Viernes',
            sabado: 'Sábado',
            domingo: 'Domingo'
        };
        return nombresDias[dia] || dia;
    });

    const horas = Object.keys(Object.values(datosHeatmap)[0] || {}).map(hora => hora);

    // Calcular valores máximo y mínimo de todos los datos
    const todosLosValores = Object.values(datosHeatmap).flatMap(dia => Object.values(dia));
    const valorMaximo = Math.max(...todosLosValores);
    const valorMinimo = Math.min(...todosLosValores);

    // Función para obtener el color basado en el valor relativo
    const obtenerColor = (valor) => {
        if (valor === 0) return '#e8f5e8'; // Verde muy claro para 0

        // Calcular el porcentaje relativo (0-1)
        const porcentajeRelativo = (valor - valorMinimo) / (valorMaximo - valorMinimo);

        // Escala de colores basada en el porcentaje relativo
        if (porcentajeRelativo <= 0.1) return '#c8e6c9'; // Verde claro (0-10%)
        if (porcentajeRelativo <= 0.3) return '#a5d6a7'; // Verde (10-30%)
        if (porcentajeRelativo <= 0.5) return '#ffeb3b'; // Amarillo (30-50%)
        if (porcentajeRelativo <= 0.7) return '#ff9800'; // Naranja (50-70%)
        if (porcentajeRelativo <= 0.9) return '#ff5722'; // Naranja rojizo (70-90%)
        return '#f44336'; // Rojo (90-100%)
    };

    // Usar estadísticas directamente de la API
    const estadisticasHeatmap = estadisticas.heatmapVolumenMensajes?.estadisticas || {};

    const horaPicoMatutina = estadisticasHeatmap.horaPicoMatutina?.hora || 'N/A';
    const horaPicoVespertina = estadisticasHeatmap.horaPicoVespertina?.hora || 'N/A';
    const horaMenorActividad = estadisticasHeatmap.horaMenorActividad?.hora || 'N/A';
    const diaPicoSemana = estadisticasHeatmap.diaPicoSemana?.dia || 'N/A';
    const mesPico = estadisticasHeatmap.mesPico?.mes || 'N/A';

    return (
        <div style={{ width: '100%', maxWidth: 800, margin: '0 auto' }}>
            {/* Título y estadísticas */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 20 }}>
                <div style={{ display: 'flex', gap: 16 }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: '#D32F2F' }}>{horaPicoMatutina} hrs</div>
                        <div style={{ fontSize: 12, color: '#666' }}>Hora pico matutina</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: '#F44336' }}>{horaPicoVespertina} hrs</div>
                        <div style={{ fontSize: 12, color: '#666' }}>Hora pico vespertina</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: '#B6C5FF' }}>{horaMenorActividad} hrs</div>
                        <div style={{ fontSize: 12, color: '#666' }}>Hora de menor actividad</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: '#F44336' }}>{diaPicoSemana}</div>
                        <div style={{ fontSize: 12, color: '#666' }}>Día pico de la semana</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: '#F44336' }}>{mesPico}</div>
                        <div style={{ fontSize: 12, color: '#666' }}>Mes pico</div>
                    </div>
                </div>
            </div>

            {/* Heatmap */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(25, 1fr)', gap: 1 }}>
                {/* Header de horas */}
                <div style={{ gridColumn: '1', height: 30 }}></div>
                {horas.map((hora, index) => (
                    <div key={hora} style={{
                        gridColumn: `${index + 2}`,
                        height: 30,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 10,
                        color: '#666',
                        fontWeight: 500
                    }}>
                        {hora}
                    </div>
                ))}

                {/* Filas de días */}
                {dias.map((dia, diaIndex) => {
                    const diaKey = Object.keys(datosHeatmap)[diaIndex];
                    return (
                        <React.Fragment key={dia}>
                            {/* Nombre del día */}
                            <div style={{
                                gridColumn: '1',
                                height: 40,
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: 12,
                                fontWeight: 600,
                                color: '#333',
                                paddingRight: 8
                            }}>
                                {dia}
                            </div>

                            {/* Celdas de datos */}
                            {horas.map((hora, horaIndex) => {
                                const valor = datosHeatmap[diaKey][hora] || 0;
                                return (
                                    <div key={`${dia}-${hora}`} style={{
                                        gridColumn: `${horaIndex + 2}`,
                                        height: 40,
                                        backgroundColor: obtenerColor(valor),
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: 12,
                                        fontWeight: 600,
                                        color: valor > 4 ? '#fff' : '#333',
                                        borderRadius: 4,
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease'
                                    }}>
                                        {valor}
                                    </div>
                                );
                            })}
                        </React.Fragment>
                    );
                })}
            </div>

            {/* Leyenda de colores */}
            <div style={{ marginTop: 20, textAlign: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 8 }}>
                    <span style={{ fontSize: 12, color: '#666' }}>Menos mensajes ({valorMinimo})</span>
                    <div style={{
                        width: 200,
                        height: 8,
                        background: 'linear-gradient(to right, #e8f5e8, #c8e6c9, #a5d6a7, #ffeb3b, #ff9800, #f44336)',
                        borderRadius: 4
                    }}></div>
                    <span style={{ fontSize: 12, color: '#666' }}>Más mensajes ({valorMaximo})</span>
                </div>
                <div style={{ fontSize: 11, color: '#999', marginTop: 4 }}>
                    Escala relativa: 0-10% (verde claro) | 10-30% (verde) | 30-50% (amarillo) | 50-70% (naranja) | 70-90% (naranja rojizo) | 90-100% (rojo)
                </div>
            </div>
        </div>
    );
};

export default Resumen;
